module.exports = __webpack_public_path__ + "static/media/text.839cfe45.svg";